export function subscribeBack() {
    var nativeData: any = {};
    nativeData['key'] = 4;
    nativeData['subscribeBack'] = true;
    // undefined or empty object will be ignored
    if(!(window as any).javascript_obj) {
        return
    }
    if(Object.keys((window as any).javascript_obj).length === 0) {
        return
    }
    (window as any).javascript_obj.nativeSupport(JSON.stringify(nativeData));
}

export function removeSubscribeBack() {
    var nativeData: any = {};
    nativeData['key'] = 4;
    nativeData['subscribeBack'] = false;
    if(!(window as any).javascript_obj){
        return
    }
    if(Object.keys((window as any).javascript_obj).length === 0) {
        return
    }
    (window as any).javascript_obj.nativeSupport(JSON.stringify(nativeData));
}

export function openDeeplink(deeplink: any) {
    var nativeData:any = {};
    nativeData['key'] = 7;
    nativeData['deeplink'] = deeplink;
    if(!(window as any).javascript_obj){
        return
    }
    if(Object.keys((window as any).javascript_obj).length === 0) {
        return
    }
    (window as any).javascript_obj.nativeSupport(
        JSON.stringify(nativeData));
}



let hMessageCb:any;
async function fetchHMessage(url:any, body:any) {
    return new Promise(function(resolve:any, reject:any){
        hMessageCb = resolve;
        let nativeData:any = {};
        nativeData['key'] = 22;
        nativeData['requestUrl'] = url;
        nativeData['requestBody'] = body;
        (window as any).javascript_obj.nativeSupport(JSON.stringify(nativeData));
    });
}


export function callbackEncryptRequest(message:any) {
    hMessageCb({message})
}


export async function getHMACHeader(
    SAVE_TASK_URL:string, options:any){
    let encryptedAnswer:any;
    if(((window as any).javascript_obj)){
    //if(false){
        encryptedAnswer = await fetchHMessage(
            SAVE_TASK_URL, options.body);
        return encryptedAnswer.message
    }
    else{
        return undefined;
    };
}
